import {
  ONEY_PSP_ID,
  PLEDG_PSP_ID,
  UPLIFT_PSP_ID,
} from 'Components/widgets/payment-info/PaymentInfo.const';
import moment from 'moment';
import { getUpliftApi } from 'Src/types/payment';
import { getKeyValue } from 'Src/i18n';
import { isPledgAllowed } from './pledg-form/PledgForm.utils';

const MAXIMUM_DAYS_BEFORE_DEPARTURE = 45;

const isBeforeDepartureLimit = ({ startDate }: { startDate: string }) => {
  const dayBeforeDeparture = moment(startDate, 'YYYYMMDD').diff(moment(), 'days');
  return dayBeforeDeparture < MAXIMUM_DAYS_BEFORE_DEPARTURE;
};

const isOneyAllowed = ({ price }: { price: number }) => {
  const maximumAllowedAmount = getKeyValue('booking.banking.paymentSchedule.bnpl.maxAmount');
  return price <= maximumAllowedAmount;
};

export const computePriceInCents = (price: number) => Math.trunc(price * 100);

export const isAllowedPaymentPlan = ({
  id,
  price,
  startDate,
}: {
  id: string;
  price: number;
  startDate: string;
}) => {
  if (id === PLEDG_PSP_ID) {
    return isPledgAllowed({ price }) && isBeforeDepartureLimit({ startDate });
  }
  if (id === ONEY_PSP_ID) {
    return isOneyAllowed({ price }) && isBeforeDepartureLimit({ startDate });
  }
  return true;
};

export const submitBuyNowPayLater = (paymentPlanId: string) => {
  switch (paymentPlanId) {
    case UPLIFT_PSP_ID:
      getUpliftApi()?.Payments.getToken();
      break;
    default:
      break;
  }
};

export const isIframeBuyNowPayLaterProvider = (paymentPlanId: string) =>
  [UPLIFT_PSP_ID, PLEDG_PSP_ID].includes(paymentPlanId);
